import {
  APP_NETWORK_ONLINE,
  APP_NETWORK_OFFLINE,
  APP_REALTIME_CLIENT_DATA_SUBSCRIBE,
  APP_REALTIME_CLIENT_DATA_UNSUBSCRIBE,
} from '../actionTypes';

const INITIAL_STATE = {};

export default function appReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case APP_NETWORK_ONLINE:
      return {
        ...state,
        online: true,
      };
    case APP_NETWORK_OFFLINE:
      return {
        ...state,
        online: false,
      };
    case APP_REALTIME_CLIENT_DATA_SUBSCRIBE:
      return {
        ...state,
        inSyncClient: action.client,
      };
    case APP_REALTIME_CLIENT_DATA_UNSUBSCRIBE:
      return {
        ...state,
        inSyncClient: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/app.reducer.js